export default "__VITE_ASSET__PNgP2Ejt__"